import React, { useState } from "react";

import { EuiBadge, EuiContextMenu, EuiPopover, EuiFilterGroup, EuiFlexItem } from "@elastic/eui";
import * as S from "./style";
import useDidUpdateEffect from "../../../hooks/useDidUpdateEffect";

const mapFieldsToContextMenuItems = (groupFields, selectedFieldId, onClickHandler) =>
    groupFields.map((field) => ({
        name: field.label,
        icon: field.id === selectedFieldId ? "check" : "empty",
        onClick: () => onClickHandler(field),
    }));

export default function ({ groupFields, onChange, defaultValue }) {
    const [selectedField, setselectedField] = useState(
        groupFields.find((field) => field.id === defaultValue?.split(".")[0]) ?? null
    );
    const [isPopoverOpen, setPopover] = useState(false);

    useDidUpdateEffect(() => {
        const reRenderContextMenu = () => {
            closePopover();
            setTimeout(() => {
                setPopover(true);
            }, 500);
        };

        reRenderContextMenu();

        onChange(
            selectedField?.id &&
                `${selectedField?.id}${selectedField?.name ? `.${selectedField.name}` : ""}`
        );
    }, [selectedField]);

    const onButtonClick = () => {
        setPopover(!isPopoverOpen);
    };

    const closePopover = () => {
        setPopover(false);
    };

    const removeSelectedField = () => {
        setselectedField(null);
    };

    const handleSelectField = (field) => {
        if (field.id === selectedField?.id) {
            removeSelectedField();
            return;
        }

        setselectedField(field);
    };

    const panels = [
        {
            id: 0,
            title: "Groups",
            items: mapFieldsToContextMenuItems(groupFields, selectedField?.id, handleSelectField),
        },
    ];

    const button = (
        <EuiFlexItem grow={1}>
            <EuiFilterGroup>
                <S.EuiFilterButtonWrapper
                    iconType="arrowDown"
                    onClick={onButtonClick}
                    isSelected={isPopoverOpen}
                >
                    Group By
                    {selectedField && (
                        <EuiBadge
                            className="groupBy-value__badge"
                            color="hollow"
                            iconType="cross"
                            iconSide="right"
                            iconOnClickAriaLabel="remove selected entity"
                            iconOnClick={removeSelectedField}
                        >
                            {selectedField.label}
                        </EuiBadge>
                    )}
                </S.EuiFilterButtonWrapper>
            </EuiFilterGroup>
        </EuiFlexItem>
    );

    return (
        <EuiPopover
            id="contextMenuExample"
            button={button}
            isOpen={isPopoverOpen}
            closePopover={closePopover}
            panelPaddingSize="none"
            anchorPosition="downLeft"
        >
            <EuiContextMenu
                initialPanelId={0}
                panels={panels}
            />
        </EuiPopover>
    );
}
